import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "text-large font-600 mr-3" }
const _hoisted_3 = {
  class: "card mb-4 mb-xxl-6",
  style: {"margin-top":"-20px"}
}
const _hoisted_4 = { class: "card-body pt-4 pb-0" }
const _hoisted_5 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "me-7 mb-4"
}
const _hoisted_7 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex align-items-center mb-2" }
const _hoisted_13 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_14 = { href: "#" }
const _hoisted_15 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_16 = { class: "list-unstyled" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "badge badge-light-success mb-1"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-light-danger mb-1"
}
const _hoisted_20 = { class: "d-flex my-4" }
const _hoisted_21 = { class: "me-0" }
const _hoisted_22 = { class: "btn btn-sm btn-danger py-2 px-4" }
const _hoisted_23 = {
  key: 0,
  class: "me-1 fa fa-cog fa-spin fs-2 p-0"
}
const _hoisted_24 = {
  key: 1,
  class: "me-1 bi bi-download fs-4 p-0"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-excel" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1)
const _hoisted_27 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_28 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_29 = { class: "d-flex flex-wrap" }
const _hoisted_30 = { class: "bg-primary text-white rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up-arrow fs-1 me-2 text-white" }, null, -1)
const _hoisted_33 = { class: "fs-2 fw-bold" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold fs-6" }, "Total", -1)
const _hoisted_35 = { class: "bg-info text-white rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-buildings fs-1 me-2 text-white" }, null, -1)
const _hoisted_38 = { class: "fs-2 fw-bold" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semobold fs-6" }, "Instituciones", -1)
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = { class: "fs-2 fw-bold" }
const _hoisted_42 = { class: "fw-semobold fs-6" }
const _hoisted_43 = { class: "d-flex align-items-center w-200px w-sm-300px flex-column" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between w-100 mt-auto mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semobold fs-6 fw-bolder" }, "Disciplina")
], -1)
const _hoisted_45 = { class: "h-5px mx-3 w-100 bg-light mb-3" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-sm-4" }
const _hoisted_48 = { class: "col-sm-8" }
const _hoisted_49 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_50 = { class: "card-title m-0" }
const _hoisted_51 = { class: "card-toolbar" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "me-3 fw-bolder" }, "Estado", -1)
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "btn btn-sm btn-secondary py-1 px-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots p-0 fs-2" })
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-excel" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_MixedWidget14 = _resolveComponent("MixedWidget14")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ModalNominal = _resolveComponent("ModalNominal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogSport,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogSport) = $event)),
      title: _ctx.evento.name,
      onOpened: _ctx.opened,
      onClosed: _ctx.oClosed,
      fullscreen: true,
      class: "bg-light"
    }, {
      header: _withCtx(({}) => [
        _createVNode(_component_el_page_header, {
          icon: _ctx.ArrowLeft,
          onBack: _ctx.onBack
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_avatar, {
                size: 32,
                class: "me-3",
                src: _ctx.evento.logo
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.evento.name), 1)
            ])
          ]),
          _: 1
        }, 8, ["icon", "onBack"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.sportDetails?.logo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_image, {
                        style: {"width":"auto","height":"130px"},
                        src: _ctx.sportDetails?.logo,
                        fit: 'cover'
                      }, null, 8, ["src"]),
                      _hoisted_8
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.sportDetails?.name) + "(" + _toDisplayString(_ctx.sportDetails?.acronym) + ")", 1),
                      _createElementVNode("a", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.sportDetails?.mstatus)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                            (_ctx.sportDetails?.mstatus=='O')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Inscripciones habilitadas"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_19, "Inscripciones finalizadas"))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_el_dropdown, null, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, {
                                command: "a",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'consolidated-participation', { 
                                                    a: _ctx.mbtoa(_ctx.evento.idevent), 
                                                    b: _ctx.mbtoa(_ctx.idsport), 
                                                    c: '' })))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_25,
                                  _createTextVNode(" Consolidado Nominal ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                command: "a",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'sumary-participation-sport', { 
                                                    a:_ctx.evento.idevent, b: _ctx.idsport, c:'' })))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_26,
                                  _createTextVNode("Resumen de participación ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                command: "a",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'zebra-zc300', { 
                                                        a: _ctx.mbtoa(_ctx.evento.idevent), 
                                                        b: _ctx.mbtoa(_ctx.idsport), 
                                                        c: '',
                                                        d: _ctx.idcheckdoc })))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Zebra ZC300 ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                command: "a",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DownloadXLSXPDF('zip', 'fotos', { 
                                                        a: _ctx.mbtoa(_ctx.evento.idevent), 
                                                        b: _ctx.mbtoa(_ctx.idsport), 
                                                        c: '',
                                                        d: _ctx.idcheckdoc })))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Fotos ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_22, [
                            (_ctx.loader)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                              : (_openBlock(), _createElementBlock("i", _hoisted_24)),
                            _createTextVNode(" " + _toDisplayString(_ctx.loader ? 'Descargando...' : 'Descargar'), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.total), 1)
                        ]),
                        _hoisted_34
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.listInstitutions.length), 1)
                        ]),
                        _hoisted_39
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRGender, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "border border-gray-500 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
                        }, [
                          _createElementVNode("div", _hoisted_40, [
                            (item.params)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(`${item.params} fs-1 me-2`)
                                }, null, 2))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_41, _toDisplayString(item.quantity), 1)
                          ]),
                          _createElementVNode("div", _hoisted_42, _toDisplayString(item.name), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.idsport,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.idsport) = $event)),
                        onChange: _ctx.changeSport,
                        filterable: "",
                        placeholder: "Seleccione",
                        class: "me-3 w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSports, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.idsport,
                              label: item.name,
                              value: item.idsport
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_MixedWidget14, {
              "widget-classes": "card-xxl-stretch mb-5 mb-xl-8",
              "widget-color": "#d9f5f8",
              loading: false,
              title: "Resumen por tipo de registro",
              items: _ctx.listRTRegister
            }, null, 8, ["items"]),
            _createVNode(_component_MixedWidget14, {
              "widget-classes": "card-xxl-stretch mb-2 mb-xl-4",
              "widget-color": "#fffcf1",
              loading: false,
              title: "Resumen por estado",
              items: _ctx.listRCheckDoc
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.searchClub,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchClub) = $event)),
                  placeholder: "Buscar",
                  "prefix-icon": _ctx.Search,
                  clearable: "",
                  class: "me-3 w-auto"
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.idcheckdoc,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.idcheckdoc) = $event)),
                  onChange: _ctx.changeSport,
                  multiple: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  placeholder: "Estado"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.filteredClubs,
              border: "",
              "show-summary": "",
              height: "400",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "abrev",
                  label: "Alias",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "business",
                  label: "Delegación"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("a", {
                      class: "cursor-pointer btn-active-color-primary",
                      onClick: ($event: any) => (_ctx.openDialogNominal(scope.row))
                    }, _toDisplayString(scope.row.business), 9, _hoisted_53)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "atleta",
                  label: "Atletas",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "oficial",
                  label: "OF. Tec",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "quantity",
                  label: "Total",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, { width: "80" }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'auxiliar', { 
                                        a: _ctx.mbtoa(_ctx.evento.idevent), 
                                        b: _ctx.mbtoa(_ctx.idsport), 
                                        c: _ctx.mbtoa(row.idinstitution) }))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_55,
                                _createTextVNode(" Ficha Axuliar ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: ($event: any) => (_ctx.openDialogNominal(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_56,
                                _createTextVNode("Ver detalles ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'nominal', { 
                                    a: _ctx.mbtoa(_ctx.evento.idevent), 
                                    b: _ctx.mbtoa(_ctx.idsport), 
                                    c: _ctx.mbtoa(row.idinstitution) }))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_57,
                                _createTextVNode("Descargar Nominal ")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_54
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _ctx.loaderTable]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onOpened", "onClosed"]),
    _createVNode(_component_ModalNominal, {
      evento: _ctx.evento,
      sport: _ctx.sportDetails,
      "row-club": _ctx.rowClub,
      checkdoc: _ctx.idcheckdoc,
      "list-status": _ctx.listStatus
    }, null, 8, ["evento", "sport", "row-club", "checkdoc", "list-status"])
  ], 64))
}